module.exports = __webpack_public_path__ + "img/blockAB41.a6080211.svg";